import { create } from 'zustand';

export type BreadcrumbItem = {
  title: string;
  href: string;
  isTabTitle?: boolean | undefined;
  tabTitles?: Array<string> | undefined;
  isCreateEditTitle?: boolean | undefined;
};

export type PageData = {
  path: string;
  pageTitle: string;
  items: Array<BreadcrumbItem>;
};

interface PageDataState {
  pageData: PageData | {};
  setPageData: (pageData: PageData) => void;
  getPageData: () => PageData | {};
}

export const usePageDataStore = create<PageDataState>((set, get) => {
  return {
    pageData: {},
    setPageData: (pageData: PageData) => {
      return set(() => {
        return { pageData };
      });
    },
    getPageData: () => {
      return get().pageData;
    },
  };
});
